import Fondo from "../assets/we.png"
import { motion } from "framer-motion";

const Nosotros = () => {
    return (
        <div className="w-full h-screen grid grid-cols-1 md:grid-cols-2">
            <motion.div
                initial={{ opacity: 0, x: -100 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1.5, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="w-full h-full bg-contain bg-center bg-no-repeat flex items-center justify-start"
                style={{ backgroundImage: `url(${Fondo})` }} 
            />
            <div className="w-full h-full flex flex-col justify-center px-4 md:px-0 md:pr-36 gap-4">
                <h1 className="font-bold text-3xl">VEN CON NOSOTROS</h1>
                <p className="text-lg text-justify">
                    <strong>CPoint</strong> te brinda el mejor servicio en administración de nómina que podrías desear.
                    Sin complicaciones, con la garantía de que tú y
                    tus colaboradores gozarán de los beneficios en cualquier lugar y en cualquier momento
                </p>
            </div>
        </div>
    );
};

export default Nosotros;